var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"c-home-hero-copy-btn"},[_c('btn',{attrs:{"tag":"router-link","url":("/" + _vm.uri),"label":"En savoir plus","type":"dark"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }